import React, { Component } from 'react'
import { Link, Redirect } from 'react-router-dom'
import { Button, Modal, Card, Menu, Row, Col, Divider } from 'antd'
import { ViewComponent } from '../../components/BaseComponent'
import Filters, { FilterItem, Types } from '../../components/Filters'
import { MappingForm } from '../../components/Forms'
import MappingStats from '../../components/MappingStats'
import { PartnerProvider, PartnerConsumer } from '../../context/PartnerContext'
import { MappingStatsProvider, MappingStatsConsumer } from '../../context/MappingStatsContext'
import { MappingAgeProvider } from '../../context/MappingAgeContext'
import { MappingAgeRangeProvider } from '../../context/MappingAgeRangeContext'
import { MappingBreedProvider } from '../../context/MappingBreedContext'
import { MappingSexProvider } from '../../context/MappingSexContext'
import { MappingSizeProvider } from '../../context/MappingSizeContext'
import { MappingSpecieProvider } from '../../context/MappingSpecieContext'
import { MappingCharacteristicProvider } from '../../context/MappingCharacteristicContext'

// Viwes
import MappingAge from './Age'
import MappingAgeRange from './AgeRange'
import MappingBreed from './Breed'
import MappingSex from './Sex'
import MappingSize from './Size'
import MappingSpecie from './Specie'
import MappingCharacteristic from './Characteristic'
import { SearchOptions } from '../../components/TableHelper'

export default class Mapping extends Component {

  private partnerDispatchOptions = {
    options: {
      _force_ids: true,
      sort: ['key']
    }
  } as const

  state = {
    currentFilters: null as any,
    currentSearchOptions: null as any,
    shouldReload: false
  }

  static getDerivedStateFromProps(props: any, state: any) {
    const { location } = props
    if (location.state) {
      if (typeof location.state.search === 'object') {
        state.currentFilters = {
          ...state.currentFilters,
          ...location.state.search
        }
      }
    }

    return state
  }

  handleFiltersChange = (data: any) => {
    this.setState({
      currentFilters: data?.search || null
    })
  }

  handleFiltersClear = () => {
    const { history, location: { pathname } }: any = this.props

    history.replace(pathname, undefined)
  }

  handleModalClose = (activeTab: string, dispatchList?: any) => {
    const { history }: any = this.props
    const { shouldReload } = this.state

    history.replace(`/integration-mapping/${activeTab}`)

    if (shouldReload && dispatchList) {
      //dispatchList()
    }
  }

  handleListOnLoad = (searchOptions: SearchOptions) => {
    this.setState({
      currentSearchOptions: searchOptions
    })
  }

  renderAdd = (activeTab: string) => {
    const { permissions, history }: any = this.props

    // Cannot create :/
    if (!permissions.create) return null

    return (
      <Button type="primary" shape="round" onClick={() => history.push(`${activeTab}/add`)}>
        Add
      </Button>
    )
  }

  renderMapping = (activeTab: string) => {
    const { permissions, history }: any = this.props
    const { currentFilters } = this.state

    switch(activeTab) {
      case 'age':
        return <MappingAge {...this.props} permissions={permissions} filters={currentFilters} history={history} onLoad={this.handleListOnLoad} />
      case 'age-range':
        return <MappingAgeRange {...this.props} permissions={permissions} history={history} onLoad={this.handleListOnLoad} />
      case 'breed':
        return <MappingBreed {...this.props} permissions={permissions} filters={currentFilters} history={history} onLoad={this.handleListOnLoad} />
      case 'sex':
        return <MappingSex {...this.props} permissions={permissions} filters={currentFilters} history={history} onLoad={this.handleListOnLoad} />
      case 'size':
        return <MappingSize {...this.props} permissions={permissions} filters={currentFilters} history={history} onLoad={this.handleListOnLoad} />
      case 'specie':
        return <MappingSpecie {...this.props} permissions={permissions} filters={currentFilters} history={history} onLoad={this.handleListOnLoad} />
      case 'characteristic':
        return <MappingCharacteristic {...this.props} permissions={permissions} filters={currentFilters} history={history} onLoad={this.handleListOnLoad} />
      default:
        return <Redirect to="/integration-mapping/age" exact />
    }
  }

  render() {
    const { permissions, history, match: { params: { activeTab, entityUuid } } }: any = this.props
    const { currentFilters, currentSearchOptions } = this.state

    if (!activeTab) return <Redirect to="/integration-mapping/age" exact />
    const selectedKeys = [activeTab] as any
    const modalVisible = entityUuid && entityUuid.length > 0

    return (
      <MappingStatsProvider>
        <PartnerProvider>
          <MappingStatsConsumer>
            {({ fetching: fetchingStats, mappingPending, requestMappingStatsPending }) => (
              <PartnerConsumer>
                {({ fetching, partners, requestPartnerList }) => {
    
                  const partnersToFilter = !partners ? [] : partners.map(partner => {
                    return {
                      value: partner.key,
                      text: partner.name || partner.key
                    }
                  })
    
                  return (
                    <>
                      <MappingStats loading={fetchingStats} mappingPending={mappingPending} loadMappingPending={requestMappingStatsPending} />
    
                      <Divider />
    
                      <Card title="Filters" style={{marginBottom: 25}}>
                        <Filters history={history} defaultSubmitOptions={this.partnerDispatchOptions} submitDispatch={this.handleFiltersChange} dispatches={[requestPartnerList]} onClearFilters={this.handleFiltersClear}>
                          {({ values, handleFilterChange }: any) => (
                            <Row gutter={9}>
                              <Col xs={24} md={6}>
                                <FilterItem
                                  name="name.ilike"
                                  type={Types.INPUT}
                                  placeholder="Filter by Name"
                                  value={values['name.ilike']}
                                  disabled={activeTab === 'age-range'}
                                  options={{
                                    input: {
                                      allowClear: true
                                    }
                                  }}
                                  onChange={handleFilterChange}
                                />
                              </Col>
              
                              <Col xs={24} md={6}>
                                <FilterItem
                                  name="partner_key"
                                  type={Types.SELECT}
                                  placeholder="Filter by Partner"
                                  loading={fetching}
                                  value={values['partner_key']}
                                  disabled={activeTab === 'age-range'}
                                  data={partnersToFilter}
                                  options={{
                                    select: {
                                      allowClear: true,
                                      showSearch: true
                                    }
                                  }}
                                  onChange={handleFilterChange}
                                />
                              </Col>
              
                              <Col xs={24} md={6}>
                                <FilterItem
                                  name="external_id"
                                  type={Types.INPUT}
                                  placeholder="Filter by External ID"
                                  value={values['external_id']}
                                  disabled={activeTab === 'age-range'}
                                  options={{
                                    input: {
                                      allowClear: true
                                    }
                                  }}
                                  onChange={handleFilterChange}
                                />
                              </Col>
              
                              <Col xs={24} md={6}>
                                <FilterItem
                                  name="active"
                                  type={Types.SELECT}
                                  placeholder="Filter by Status"
                                  value={values['active']}
                                  defaultValue={currentFilters?.active}
                                  disabled={activeTab === 'age-range'}
                                  data={[
                                    {
                                      text: 'Active',
                                      value: 'true'
                                    },
                                    {
                                      text: 'Disabled',
                                      value: 'false'
                                    }
                                  ]}
                                  options={{
                                    select: {
                                      allowClear: true,
                                      showSearch: false
                                    }
                                  }}
                                  onChange={handleFilterChange}
                                />
                              </Col>
                            </Row>
                          )}
                        </Filters>
                      </Card>
                      
                      <MappingAgeProvider>
                        <MappingAgeRangeProvider>
                          <MappingBreedProvider>
                            <MappingSexProvider>
                              <MappingSizeProvider>
                                <MappingSpecieProvider>
                                  <MappingCharacteristicProvider>
                                    <Card title="Mappings" extra={this.renderAdd(activeTab)}>
                                      <Menu selectedKeys={selectedKeys} mode="horizontal">
                                        <Menu.Item key="age">
                                          <Link to="age">Age</Link>
                                        </Menu.Item>
                                        <Menu.Item key="age-range">
                                          <Link to="age-range">Age Range</Link>
                                        </Menu.Item>
                                        <Menu.Item key="breed">
                                          <Link to="breed">Breed</Link>
                                        </Menu.Item>
                                        <Menu.Item key="sex">
                                          <Link to="sex">Sex</Link>
                                        </Menu.Item>
                                        <Menu.Item key="size">
                                          <Link to="size">Size</Link>
                                        </Menu.Item>
                                        <Menu.Item key="specie">
                                          <Link to="specie">Species</Link>
                                        </Menu.Item>
                                        <Menu.Item key="characteristic">
                                          <Link to="characteristic">Characteristic</Link>
                                        </Menu.Item>
                                      </Menu>
      
                                      <div style={{marginTop: 20}}>
                                        <ViewComponent permissions={permissions} check="list">
                                          {this.renderMapping(activeTab)}
                                        </ViewComponent>
                                      </div>
                                    </Card>
      
                                    <Modal
                                      title="Mapping"
                                      visible={modalVisible}
                                      footer={null}
                                      destroyOnClose={true}
                                      onCancel={() => this.handleModalClose(activeTab)}
                                    >
                                      {
                                        // We should re-render the form, because our form trash need to be cleared
                                        modalVisible ? (
                                          <MappingForm activeTab={activeTab} loadingContent={fetching} partners={partners} uuid={entityUuid !== 'add' ? (entityUuid || null) : null} searchOptions={currentSearchOptions} loadPartners={requestPartnerList} />
                                        ) : null
                                      }
                                    </Modal>
                                  </MappingCharacteristicProvider>
                                </MappingSpecieProvider>
                              </MappingSizeProvider>
                            </MappingSexProvider>
                          </MappingBreedProvider>
                        </MappingAgeRangeProvider>
                      </MappingAgeProvider>
                    </>
                  )
                }}
              </PartnerConsumer>
            )}
          </MappingStatsConsumer>
        </PartnerProvider>
      </MappingStatsProvider>
    )
  }
}
